import React, { useContext, useId } from 'react'
import { ComponentConfig, renderContext } from '@puckeditor/core'
import { ColorField } from 'breaktime-theme/src/puck/fields/ColorField'
import {
  TypographyProps,
  fontFamilyField,
  fontFamilyFallbackField,
  textTransformField,
  fontWeightOptions,
  applyTypography,
  FontWeight,
} from 'breaktime-theme/src/puck/fields/StyleFields'

export type PollSkipButtonProps = {
  label?: string
  textColor?: string
  fontFamily?: TypographyProps['fontFamily']
  fontFamilyFallback?: TypographyProps['fontFamilyFallback']
  textTransform?: TypographyProps['textTransform']
  fontSize?: string
  fontWeight?: FontWeight
}

export const POLL_SKIP_BUTTON_DEFAULT_PROPS: PollSkipButtonProps = {
  label: 'Skip This Activity',
  textColor: '',
}

export const PuckPollSkipButton: ComponentConfig<PollSkipButtonProps> = {
  label: 'Poll Skip Button',
  defaultProps: POLL_SKIP_BUTTON_DEFAULT_PROPS,
  permissions: {
    drag: true,
    duplicate: false,
    delete: true,
  },
  fields: {
    label: { type: 'text', label: 'Button Label' },
    textColor: {
      type: 'custom',
      label: 'Text Color',
      render: (props: any) => <ColorField {...props} clearable />,
    },
    fontFamily: fontFamilyField,
    fontFamilyFallback: fontFamilyFallbackField,
    textTransform: textTransformField,
    fontSize: { type: 'text', label: 'Font Size', placeholder: '14px' },
    fontWeight: { type: 'select', label: 'Font Weight', options: fontWeightOptions },
  },
  render: props => <PollSkipButtonRender {...(props as PollSkipButtonProps)} />,
}

function PollSkipButtonRender({
  label,
  textColor,
  fontFamily,
  fontFamilyFallback,
  textTransform,
  fontSize,
  fontWeight,
}: PollSkipButtonProps) {
  const puckCtx = useContext(renderContext)
  const meta = (puckCtx.metadata ?? {}) as any
  const onStepSkip = meta.onStepSkip as ((id?: string) => void) | undefined
  const stepId = meta.step?.id as string | undefined

  const baseStyle: React.CSSProperties = {
    ...applyTypography({ fontFamily, fontFamilyFallback, textTransform }),
    ...(fontSize ? { fontSize } : {}),
    ...(fontWeight ? { fontWeight: Number(fontWeight) || undefined } : {}),
    ...(textColor ? { color: textColor } : {}),
  }

  return (
    <div className="skip-button-will-appear-here">
      <div className="skip-button-container">
        <button
          type="button"
          className="btn-skip"
          aria-label={label || 'Skip This Activity'}
          style={baseStyle}
          onClick={() => onStepSkip?.(stepId)}
        >
          {label || 'Skip This Activity'}
        </button>
      </div>
    </div>
  )
}
